import * as React from "react";
import styled from "styled-components";
import EventsMetrics from "components/events/EventsMetrics";
import EventsCategoriesHistogram from "security-app/components/SecurityEvents/Alerts/MitreCategories/EventsCategoriesHistogram";
import ExportResultsButton from "security-app/components/SecurityEvents/Alerts/ExportResultsButton";
import MetricsAction from "security-app/components/SecurityEvents/Alerts/MetricsAction";
import SecurityEventsHistogram from "security-app/components/SecurityEvents/Alerts/SecurityEventsHistogram";
import IfPermitted from "components/common/IfPermitted";
import permissions from "security-app/Permissions";
const WidgetsContainer = styled.div`
  display: flex;
  gap: 5px;
`;
const EventsHistogramContainer = styled.div`
  flex: 3;
`;
const CategoriesHistogramContainer = styled.div`
  flex: 2;
`;
const AlertsWidgets = ({ searchParams, setFilters }) => /* @__PURE__ */ React.createElement(EventsMetrics, null, /* @__PURE__ */ React.createElement(WidgetsContainer, null, /* @__PURE__ */ React.createElement(EventsHistogramContainer, null, /* @__PURE__ */ React.createElement(MetricsAction, null, /* @__PURE__ */ React.createElement(ExportResultsButton, { type: "alerts", title: "alerts", searchParams })), /* @__PURE__ */ React.createElement(SecurityEventsHistogram, { searchParams, setFilters })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [permissions.securityApp.read] }, /* @__PURE__ */ React.createElement(CategoriesHistogramContainer, null, /* @__PURE__ */ React.createElement(EventsCategoriesHistogram, { searchParams, setFilters })))));
export default AlertsWidgets;
